// Module
var code = "<react-component name=\"PosReconciliation\"></react-component>\n";
// Exports
module.exports = code;